/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./async-component-config.vue?vue&type=template&id=6effa404&scoped=true&"
import script from "./async-component-config.vue?vue&type=script&lang=js&"
export * from "./async-component-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6effa404",
  null
  
)

export default component.exports